import { ComponentPropsWithoutRef, useState } from "react";
import ModalLayout from "components/modal/modal-layout/ModalLayout";
import ConfirmModal from "components/confirm-modal";
import RadioButton from "components/radio-button";

import styles from "./DeleteBlockedIntervalSeries.module.scss";
import deleteBlockedIntervalSeries from "services/scheduler/deleteBlockedIntervalSeries";
import deleteBlockedInterval from "services/scheduler/deleteBlockedInterval";

const DELETE_OPTIONS = [
  { label: "Only this blocked time", value: "this_blocked_interval" },
  {
    label: "All blocked times in the series",
    value: "all_blocked_intervals",
  },
];

type Props = Pick<
  ComponentPropsWithoutRef<typeof ModalLayout>,
  "show" | "onHide" | "onConfirm"
> & {
  blockedInterval: CalendarBlockedInterval;
};

const DeleteBlockedIntervalSeriesModal = ({
  show,
  onHide,
  onConfirm,
  blockedInterval,
}: Props) => {
  const [deleteOption, setDeleteOption] = useState("this_blocked_interval");

  const [error, setError] = useState<any>();
  const [busy, setBusy] = useState(false);

  const handleHide = () => {
    setError(undefined);
    setBusy(false);
    setDeleteOption("this_blocked_interval");
    onHide();
  };

  const onDeleteOptionChange = (event) => {
    const inputField = event.currentTarget;
    setDeleteOption(inputField.value);
  };

  const onDeleteSeries = async () => {
    setBusy(true);
    try {
      if (deleteOption === "this_blocked_interval") {
        await deleteBlockedInterval(blockedInterval);
      } else {
        if (!blockedInterval.uuid) {
          setError("Blocked interval UUID is missing");
          setBusy(false);
          return;
        }
        await deleteBlockedIntervalSeries(blockedInterval.uuid);
      }
      onConfirm();
      handleHide();
    } catch (error) {
      setError(error);
    } finally {
      setBusy(false);
    }
  };

  return (
    <ConfirmModal
      labelTitle={"Delete Recurring Blocked Times?"}
      children={
        <div>
          <p>
            Would you like to delete only this blocked time, OR all blocked
            times in the series?
          </p>
          {DELETE_OPTIONS.map((option) => (
            <RadioButton
              key={option.value}
              className={styles["delete-series-modal__radio"]}
              id={option.value}
              label={option.label}
              value={option.value}
              name="delete-option"
              onChange={onDeleteOptionChange}
              checked={deleteOption === option.value}
            />
          ))}
        </div>
      }
      labelConfirm={"Confirm"}
      hideCancel={true}
      show={show}
      onCancel={() => {
        handleHide();
      }}
      onConfirm={() => onDeleteSeries()}
      disabled={busy}
      error={error}
    />
  );
};

export default DeleteBlockedIntervalSeriesModal;
